<template>
	<article class="blog-card">
		<div class="blog-card__thumbnail">
			<img :src="data.thumbnail || cardDefault" :alt="data.title" />
		</div>
		<div class="blog-card__body">
			<div class="blog-card__meta">
				<span class="blog-card__date">{{ formattedDate }}</span>
				<span
v-if="data.readtime"
class="blog-card__readtime"
					>{{ data.readtime }} min</span
				>
			</div>
			<h3 class="blog-card__title">{{ data.title }}</h3>
			<p class="blog-card__description">{{ data.description }}</p>
			<span v-if="data.author" class="blog-card__author">{{
				data.author
			}}</span>
		</div>
	</article>
</template>

<script setup>
import dayjs from "dayjs";
import cardDefault from "@/assets/images/blog/card-default.png";

const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
});

const formattedDate = computed(() =>
	dayjs(props.data.createdDate).format("MMM D, YYYY"),
);
</script>

<style lang="scss" scoped>
.blog-card {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	border-radius: 12px;
	overflow: hidden;
	background: color-mix(in oklab, #0d1015, white 10%);
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 28px rgba(0, 0, 0, 0.13);
	}

	&__thumbnail {
		width: 100%;
		aspect-ratio: 16 / 9;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: transform 0.3s ease;
		}
	}

	&:hover &__thumbnail img {
		transform: scale(1.04);
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 20px;
		flex: 1;
	}

	&__meta {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	&__date {
		font-size: 13px;
		color: #7a8a99;
	}

	&__readtime {
		font-size: 13px;
		color: $app-color;
		font-weight: 600;

		&::before {
			content: "·";
			margin-right: 12px;
			color: #7a8a99;
		}
	}

	&__title {
		font-size: 18px;
		font-weight: 700;
		color: #fff;
		line-height: 1.35;
		margin: 0;
	}

	&__description {
		font-size: 14px;
		color: #5a6a78;
		line-height: 1.6;
		margin: 0;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	&__author {
		margin-top: auto;
		font-size: 13px;
		font-weight: 600;
		color: #fff;
	}
}
</style>
